// tanstack
import { useParams } from '@tanstack/react-router';

// relative
import { useGetAccountByIdQuery } from '../api/recalc/endpoints/accountsApiSlice';

/**
 * Custom hook to check if an account has a specific service
 * @param {string} serviceName - The name of the service to check for (e.g., 'EnergyXplorer')
 * @returns {Object} - { hasService: boolean, account: Object, isLoading: boolean, error: Object }
 */
export const useHasService = (serviceName) => {
  const { accountId } = useParams({ strict: false });

  const {
    data: account,
    isLoading,
    error,
  } = useGetAccountByIdQuery(accountId, {
    skip: !accountId,
  });

  const hasService =
    account?.Services?.some((s) => s.Name === serviceName) ?? false;

  return {
    hasService,
    account,
    isLoading,
    error,
  };
};
